import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout: hijos en index y devoluciones. */
export const Route = createFileRoute("/app/ordenes")({
  component: () => <Outlet />,
});
